var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionsNewsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 7.5H15.3125V4.375C15.3125 2.65312 13.9094 1.25 12.1875 1.25H4.6875C2.96562 1.25 1.5625 2.65312 1.5625 4.375V15.625C1.5625 17.3469 2.96562 18.75 4.6875 18.75H16.25C17.4563 18.75 18.4375 17.7687 18.4375 16.5625V9.0625C18.4375 8.2 17.7375 7.5 16.875 7.5ZM2.8125 15.625V4.375C2.8125 3.34063 3.65313 2.5 4.6875 2.5H12.1875C13.2219 2.5 14.0625 3.34063 14.0625 4.375V16.5625C14.0625 16.8969 14.1406 17.2156 14.2781 17.5H4.6875C3.65313 17.5 2.8125 16.6594 2.8125 15.625ZM17.1875 16.5625C17.1875 17.0781 16.7656 17.5 16.25 17.5C15.7344 17.5 15.3125 17.0781 15.3125 16.5625V8.75H16.875C17.0469 8.75 17.1875 8.89062 17.1875 9.0625V16.5625Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 5.625H5C4.65625 5.625 4.375 5.90625 4.375 6.25C4.375 6.59375 4.65625 6.875 5 6.875H11.875C12.2188 6.875 12.5 6.59375 12.5 6.25C12.5 5.90625 12.2188 5.625 11.875 5.625Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 9.375H5C4.65625 9.375 4.375 9.65625 4.375 10C4.375 10.3438 4.65625 10.625 5 10.625H11.875C12.2188 10.625 12.5 10.3438 12.5 10C12.5 9.65625 12.2188 9.375 11.875 9.375Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.125H5C4.65625 13.125 4.375 13.4062 4.375 13.75C4.375 14.0938 4.65625 14.375 5 14.375H8.75C9.09375 14.375 9.375 14.0938 9.375 13.75C9.375 13.4062 9.09375 13.125 8.75 13.125Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsNewsIcon);
export default __webpack_public_path__ + "static/media/subscriptions-news-icon.832a2beecce37badadaa808ce807e1e9.svg";
export { ForwardRef as ReactComponent };